module.exports = __webpack_public_path__ + "static/img/7-4.5d1c684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/7-4.png
// module id = AfDS
// module chunks = 25